import { render, staticRenderFns } from "./TableWithDetails.vue?vue&type=template&id=ac6c9f84&scoped=true&"
import script from "./TableWithDetails.vue?vue&type=script&lang=js&"
export * from "./TableWithDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableWithDetails.vue?vue&type=style&index=0&id=ac6c9f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6c9f84",
  null
  
)

export default component.exports